export const GET_LIST_VIDEO_LIBRARY = "GET_LIST_VIDEO_LIBRARY";
export const GET_LIST_VIDEO_LIBRARY_SUCCESS = "GET_LIST_VIDEO_LIBRARY_SUCCESS";
export const GET_LIST_VIDEO_LIBRARY_ERROR = "GET_LIST_VIDEO_LIBRARY_ERROR";
export const CLEAR_LIST_VIDEO_LIBRARY = 'CLEAR_LIST_VIDEO_LIBRARY';

export const GET_VIDEO = "GET_VIDEO";
export const GET_VIDEO_SUCCESS = "GET_VIDEO_SUCCESS";
export const GET_VIDEO_CLEAR = "GET_VIDEO_CLEAR";
export const GET_VIDEO_ERROR = "GET_VIDEO_ERROR";

export const CREATE_VIDEO = "CREATE_VIDEO";
export const CREATE_VIDEO_SUCCESS = "CREATE_VIDEO_SUCCESS";
export const CREATE_VIDEO_CLEAR = "CREATE_VIDEO_CLEAR";
export const CREATE_VIDEO_ERROR = "CREATE_VIDEO_ERROR";

export const UPDATE_VIDEO = "UPDATE_VIDEO";
export const UPDATE_VIDEO_SUCCESS = "UPDATE_VIDEO_SUCCESS";
export const UPDATE_VIDEO_CLEAR = "UPDATE_VIDEO_CLEAR";
export const UPDATE_VIDEO_ERROR = "UPDATE_VIDEO_ERROR";

export const REMOVE_VIDEO = "REMOVE_VIDEO";
export const REMOVE_VIDEO_SUCCESS = "REMOVE_VIDEO_SUCCESS";
export const REMOVE_VIDEO_CLEAR = "REMOVE_VIDEO_CLEAR";
export const REMOVE_VIDEO_ERROR = "REMOVE_COURSE_ERROR";

export const EXPORT_VIDEO_LIBRARY_REPORT = "EXPORT_VIDEO_LIBRARY_REPORT";
export const EXPORT_VIDEO_LIBRARY_REPORT_SUCCESS = "EXPORT_VIDEO_LIBRARY_REPORT_SUCCESS";
export const EXPORT_VIDEO_LIBRARY_REPORT_ERROR = "EXPORT_VIDEO_LIBRARY_REPORT_ERROR";